"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tertiaryButtons = void 0;
var material_1 = require("@mui/material");
exports.tertiaryButtons = [
    {
        props: { variant: 'tertiaryDefault' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.text.disabled, 0.2),
                },
                '&:focus': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.text.disabled, 0.2),
                },
                '&:active': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.text.disabled, 0.6),
                },
                '&:disabled': {
                    color: theme.palette.text.disabled,
                },
            });
        },
    },
    {
        props: { variant: 'tertiaryHC' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.text.light,
                '&:hover': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.text.disabled, 0.2),
                },
                '&:focus': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.text.disabled, 0.2),
                },
                '&:active': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.text.disabled, 0.6),
                },
                '&:disabled': {
                    color: theme.palette.text.disabled,
                },
            });
        },
    },
];
